<template>
  <div class="sign-in">
  <h1>Logowanie</h1>
  <form>
    <EmailLoginInput />
    <PasswordLoginInput />

    <p v-if="!credentialsValid" class="error">Nieprawidłowe dane!</p>
    <p v-if="unknownError" class="error">Wystąpił nieznany błąd.
      Prosimy skontaktować się z naszą pomocą techniczną pod adresem
      biuro@followup.social</p>
    <p v-if="connectionError" class="error">Nie udało połączyć się z serwerem.
      Prosimy sprawdzić stan połączenia sieciowego.</p>
    <p v-if="sessionExpired" class="error">Sesja wygasła.</p>
    <RememberLoginCheckbox />
  </form>
  <button class="valid" :class="{'btn-grayed': !formFilled || !loginCredentialsValid}"
  @click.prevent="login">Zaloguj się</button>
  <p class="question">Nie masz konta?</p>
  <button @click.prevent="proceedToRegistrationForm"
    class="btn-gray btn-small">Zarejestruj się</button>
</div>
</template>

<script>
import EmailLoginInput from '@/components/authentication/inputs/login/EmailLoginInput.vue';
import PasswordLoginInput from '@/components/authentication/inputs/login/PasswordLoginInput.vue';
import RememberLoginCheckbox from '@/components/authentication/inputs/login/RememberLoginCheckbox.vue';

export default {
  name: 'LoginForm',
  components: {
    EmailLoginInput,
    PasswordLoginInput,
    RememberLoginCheckbox
  },
  computed: {
    connectionError() {
      return this.$store.getters.connectionAuthError;
    },
    unknownError() {
      return this.$store.getters.unknownAuthError;
    },
    sessionExpired() {
      return this.$store.getters.loginSessionExpired;
    },
    credentialsValid() {
      return this.$store.getters.loginCredentialsValid;
    },
    formFilled() {
      return this.$store.getters.loginFormFilled;
    },
    loginCredentialsValid() {
      return this.$store.getters.loginCredentialsValid;
    }
  },
  methods: {
    login() {
      if (!this.formFilled) return;
      this.$store.dispatch('clearAllAuthErrors');
      this.$store.dispatch('login');
    },
    proceedToRegistrationForm() {
      this.$store.commit('proceedToRegistrationForm');
    }
  }
};
</script>
